import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { loginApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  login_data: null
};

const LoginSlice = createSlice({
  name: 'Login',
  initialState,
  reducers: {
    setLogin(state, action) {
      state.login_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Login Data
export const getLoginData = (data) => async (dispatch) => {
  dispatch(setLogin(null));
  dispatch(setIsLoading({ loading: true }));

  try {
    const res = await fireApi({
      endpoint: loginApi?.login,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLogin(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLogin(null)); // store in redux
      dispatch(setApiError(res?.error));
      console.error('❌ Login Data failed rrrrr', res?.error);
      return null;
    }
  } catch (error) {
    dispatch(setLogin(null));
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Login Data exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setLogin } = LoginSlice.actions;
export default LoginSlice.reducer;
